import { Button, Typography } from "@material-ui/core";
import { MouseEventHandler } from "react";

type CustomButtonProps = React.PropsWithChildren<{
  disabled?: boolean;
  padding?: string;
  fontSize?: string;
  color?: "primary" | "darkButtonBg";
  onClick?: MouseEventHandler<HTMLButtonElement>;
}>;

export const CustomButton = (props: CustomButtonProps) => {
  // const theme = useTheme();

  return (
    <Button
      variant="contained"
      color={props.color || "primary"}
      disableElevation
      size="small"
      sx={{
        textTransform: "none",
        padding: props.padding,
      }}
      {...props}
    >
      <Typography
        variant="bold"
        color="white"
        fontSize={props.fontSize}
        lineHeight={props.fontSize}
      >
        {props.children}
      </Typography>
    </Button>
  );
};
